import server from "@/api/server";

// Грид
async function appsList(data) {
  const res = await server.post("/agent/agent/app/manager_list", data);
  return res;
}

// информация для SidePanel "Компания"
async function appInfo(id) {
  const res = await server.post("/agent/agent/app/get", id);
  return res;
}

// получения логов
async function uploadLog({ id }) {
  let res = await server.post("agent/management/app/get-orchestrator-logs", { id });
  return res;
}

// получения данных по задаче из логов
async function fetchTaskData({ taskId }) {
  return await server.post("agent/management/app/get-orchestrator-task-data", { id: taskId });
}

// перезапуска заявки
async function appRestart({ id, stop_reason, options, selected_options }) {
  let res = await server.post("agent/management/app/reset-and-send", { id, stop_reason, options, selected_options });
  return res;
}

// "касания" к заявке
async function appTouch({ id, data }) {
  let res = await server.post("agent/agent/app/touch", { id, ...data });
  return res;
}

async function appRequestExternalSynchronization({ id, type }) {
  let res = await server.post("agent/management/app/request-external-synchronization", { id, type });
  return res;
}

async function appRetryOrchestratorProcess({ id }) {
  let res = await server.post("agent/management/app/retry-orchestrator-process", { id });
  return res;
}

async function appSetOrchestratorPhone({ id, phoneNumber }) {
  let res = await server.post("agent/management/app/set-orchestrator-phone", { id, phone_number: phoneNumber });
  return res;
}

async function appSendOrchestratorArchive({ id }) {
  let res = await server.post("agent/management/app/send-orchestrator-archive", { id });
  return res;
}

async function appSendOkvedDecision({ id, decision }) {
  return server.post("agent/management/app/send-okved-decision", { id, decision });
}

export {
  appsList,
  appInfo,
  uploadLog,
  fetchTaskData,
  appRestart,
  appTouch,
  appRequestExternalSynchronization,
  appRetryOrchestratorProcess,
  appSetOrchestratorPhone,
  appSendOrchestratorArchive,
  appSendOkvedDecision
};
